import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function getQueryParam(key) {
  return new URL(document.location).searchParams.get(key);
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function textTruncate(text, maxLength) {
  return text && text.length > maxLength
    ? text.substr(0, maxLength) + "..."
    : text;
}

function formatDate(dateString) {
  const date = new Date(dateString);
  // Define options for formatting
  const options = { year: "numeric", month: "short", day: "2-digit" };
  return dateString ? date.toLocaleDateString("en-US", options) : "";
}
export { ScrollToTop, getQueryParam, textTruncate, formatDate };
